<!--
 * @Description: 附件组件
 * @Author: wangwangwang
 * @Date: 2020-12-14 11:06:22
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-08-02 16:35:57
-->
<template>
  <section>
    <el-upload v-if="upload" :disabled="disabled" :action="action" :show-file-list="false" :before-upload="beforeUpload" :on-success="filesuccess" :headers="upheader">
      <el-link :underline="false" :disabled="disabled">{{message}}</el-link>
      <div slot="tip" class="el-upload__tip" style="color:red">*{{upload_tip}}</div>
    </el-upload>
    <div style="margin-top:10px;">
      <div v-for="(item, index) in files" :key="index" class="upload-item-text">
        <i class="icon iconfont iconhome_icon_txt"></i>
        <span @click="$wps(item.fileUrl || item.filePath,fileMessage.watermark)">{{item.fileName}}</span>
        <a v-show="fileMessage.download" class="el-link" :href="'/file/' + (item.fileUrl || item.filePath)" download>
          <i class="el-icon-download" style="padding:0 10px"></i>
        </a>
        <i v-show="fileMessage.deleteLimit&&upload" class="icon iconfont iconzu2197" @click="delfile(index)"></i>
      </div>
    </div>
  </section>
</template>
<script>
import { getToken, getUserId } from '@/utils/auth';
import { getFileDetails } from '@/api/common';
import { Loading } from 'element-ui';
import { UPLOAD_TIP } from "@/utils/utils";
let loadingInstance;
export default {
  props: {
    action:{
      type:String,
      default: '/resource/resources/upload'
    },
    files: {
      type: Array,
      default: ()=>[]
    },
    fileCode: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    upload: {
      type: Boolean,
      default: true
    },
    message:{
      type: String,
      default: '选择附件'
    },
  },
  data() {
    return {
      fileMessage: {},
      upheader: {
        "access-token": getToken(),
        "user-id": getUserId(),
        timeout:300000,
      },
      upload_tip:UPLOAD_TIP,
    }
  },
  methods: {
    delfile(index) {
      this.$emit('deleteFile', index);
    },
    beforeUpload(file) {
      if (!this.fileMessage || !this.fileMessage ?.fileType) {
        this.$message.error('当前流程未配置附件，请配置后再进行上传');
        return false;
      }
      const fileTypes = file.name.split('.');
      const fileType = fileTypes[fileTypes.length-1];
      const isTYPE = this.fileMessage.fileType.indexOf(fileType) > -1;
      const isLtM = file.size / 1024 / 1024 < this.fileMessage.trillionSize;
      if (!isTYPE) {
        this.$message.error('文件格式只能为' + this.fileMessage.fileType);
        return false;
      }
      if (!isLtM) {
        this.$message.error(`文件大小不能超过${this.fileMessage.trillionSize}M`);
        return false;
      }
      loadingInstance = Loading.service({ text: '上传中...' });
      return true;
    },
    filesuccess(res) {
      if (res.code === 1001) {
        this.$emit('uplodeSuccess', res.data);
        loadingInstance.close();
      }
    },
  },
  mounted() {
    getFileDetails({ code: this.fileCode }).then(res => {
      if (res.code === 1001) {
        this.fileMessage = res.data;
      }
    })
  }
}
</script>
<style lang="scss" scoped>
.upload-item-text {
  cursor: pointer;
  padding: 0px 10px;
  margin: 0 20px 10px 0px;
  border: 1px solid #e1e5ed;
  border-radius: 4px;
  display: inline-block;
  line-height: 30px;
  .iconhome_icon_txt {
    color: $bg_color;
    font-size: 14px;
    padding-right: 10px;
  }
  .iconzu2197:hover {
    color: $bg_color;
  }
  .iconzu2197 {
    color: #c0c4cc;
    font-size: 14px;
  }
}
.el-link {
  color: $bg_color;
}
.el-link:hover {
  color: $bg_color;
  opacity: 0.7;
}
</style>
